import api from '@/helpers/api';

class PointExpirationService {
  getSummary(corporateId) {
    return api.request('get', '/api/point-expiration/summary/' + corporateId);
  }

  getHistory(corporateId, params = {}) {
    return api.request('get', '/api/point-expiration/history/' + corporateId, params);
  }

  getConfig(corporateId) {
    return api.request('get', '/api/point-expiration/config/' + corporateId);
  }

  updateConfig(corporateId, data) {
    return api.request('put', '/api/point-expiration/config/' + corporateId, {}, data);
  }
}

export default new PointExpirationService();
